/**
 * Skeleton placeholder shown during stage="submitting". Mirrors the
 * FeedbackBubble shell (tutor avatar + accent-soft fill) so the swap-in
 * when the grade lands doesn't reflow. Shimmer is opacity-only.
 */
export function FeedbackBubbleSkeleton() {
	return (
		<div
			role="status"
			aria-live="polite"
			aria-label="Beoordeling bezig"
			className="flex items-start gap-3.5 rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--accent-soft)] p-5 sm:p-6"
		>
			<span
				aria-hidden
				className="h-9 w-9 shrink-0 rounded-full bg-[var(--accent)] opacity-50 skeleton-shimmer"
			/>
			<div className="flex-1 space-y-2.5" aria-hidden>
				<div className="h-3 w-2/3 rounded-full skeleton-shimmer" />
				<div className="h-3 w-11/12 rounded-full skeleton-shimmer" />
				<div className="h-3 w-1/2 rounded-full skeleton-shimmer" />
			</div>
		</div>
	);
}
